import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { SessionStorageService } from './../services/session/sessionstorage.service'


@Injectable()
export class AuthService {
  private loggedIn = new BehaviorSubject<boolean>(false);
  private loggedInRole = new BehaviorSubject<string>('');

  get isLoggedIn() {
    if (this.ss.getUserInfo != null) {
      this.loggedIn.next(true);
    }
    else {
      this.loggedIn.next(false);
    }
    return this.loggedIn.asObservable(); // {2}
  }

  get getRole() {
    if (this.ss.getUserInfo != null) {    
      this.loggedInRole.next(this.ss.getUserInfo.userRole);
    }
    else {
      this.loggedInRole.next('');
    }
    return this.loggedInRole.asObservable(); // {2}
  }

  constructor(private router: Router, private ss: SessionStorageService) {
      
  }

  login(user:any) {
    this.ss.setUserInfo(user);
      /*this.loggedIn.next(true)*/;
      this.router.navigate(['/']);
    }
  
  logout() {
    this.ss.setUserInfo(null)// {4}
    this.loggedIn.next(false);
    this.router.navigate(['/login']);
  }

}
